import clsx from 'clsx';
import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import Dropzone, { DropzoneRef } from 'react-dropzone';
import { T } from '../../../../Translations';
import Button from '../../../Form/Button';
import ImportParticipantsStore from '../Store';

interface Props {
  store: ImportParticipantsStore;
}

const DragAndDrop: React.FC<Props> = ({ store }) => {
  const dropzoneRef: React.RefObject<DropzoneRef | null> = React.createRef();

  const openDialog = () => {
    fromNullable(dropzoneRef.current).map((dropzoneRefCurrent) => dropzoneRefCurrent.open());
  };

  const onDrop = (acceptedFiles: File[]) => {
    fromNullable(acceptedFiles.at(0)).do((fileObj) => {
      store.fileSelected(fileObj);
    });
  };

  return (
    <div
      className={clsx(
        'mx-11 mb-7 flex justify-center rounded-md border',
        'border-solid bg-gray-50 px-4 py-7',
      )}
    >
      <Dropzone
        ref={dropzoneRef}
        onDrop={onDrop}
        noClick
        accept={{ 'text/csv': ['.csv'] }}
        multiple={false}
      >
        {({ getRootProps, getInputProps }) => (
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} aria-label="Upload CSV file" />
              <p className="text-center">
                <T kind="Drag 'n' drop your csv file here ..." />
              </p>
              <div className="mt-2 flex justify-center">
                <Button
                  type="button"
                  onClick={openDialog}
                  value="Upload file"
                  className={clsx(
                    'cursor-pointer rounded-md border border-solid font-semibold',
                    'bg-teal-600 px-4 py-2 text-base text-white',
                  )}
                  disabled={store.uploadButtonDisabled}
                />
              </div>
            </div>
          </section>
        )}
      </Dropzone>
    </div>
  );
};

export default observer(DragAndDrop);
